import React, { Component } from "react";
import PropTypes from 'prop-types';
import { ContentMessagesAPIs } from "../../services/drupalServices";
import { ContentDiv } from "../commonStyles";
import Preloader from "../Preloader/Preloader";

const Contents = React.createContext(null);

export default Contents;

export const Types = {
	PAGE_TITLE_DESCRIPTION: 'page_title_description',
	PAGE_NOTICES: 'page_notices',
	PAGE_DISCLAIMERS: 'page_disclaimers',
	PAGE_PDF_LINKS: 'pdf_links',
	SUB_HEADING_LEGACY_OPTIONS: 'sub_headings_desc_legacy_options',
	GET_CONFIRMATION_MESSAGE: 'confirmation_message',
	GET_MODAL_CONTENT: 'get_modal_content',
	PAGE_ALERTS: "alert_messages",
	PAGE_PLEASE_NOTE: "page_please_note",
	PAGE_PERMISSION_TO_PUBLISH: "page_permission_to_publish",
	PAGE_CHECKBOX: "page_checkbox",
};

export class ContentProvider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			page_title_description: {},
			page_notices: {},
			page_disclaimers: {},
			pdf_links: {},
			sub_headings_desc_legacy_options: {},
			confirmation_message: {},
			get_modal_content: {},
			alert_messages:{},
			page_please_note: {},
			page_permission_to_publish: {},
			page_checkbox: {}
		};
	}

	addPageTitleAndDescriptions(newContents) {
		this.setState({ page_title_description: { ...this.state.page_title_description, ...newContents } });
	}
	addNotices(newContents) {
		this.setState({ page_notices: { ...this.state.page_notices, ...newContents } });
	}
	addDisclaimers(newContents) {
		this.setState({ page_disclaimers: { ...this.state.page_disclaimers, ...newContents } });
	}
	addModalContent(newContents) {
		this.setState({ get_modal_content: { ...this.state.get_modal_content, ...newContents } });
	}
	addPdf(newContents) {
		this.setState({ pdf_links: { ...this.state.pdf_links, ...newContents } });
	}
	addSubHeadingLegacyOptions(newContents) {
		this.setState({ sub_headings_desc_legacy_options: { ...this.state.sub_headings_desc_legacy_options, ...newContents } });
	}
	getConfirmationMessage(newContents){
		this.setState({ confirmation_message: { ...this.state.confirmation_message, ...newContents } }, () => {});
	}
	addPleaseNote(newContents) {
		this.setState({ page_please_note: { ...this.state.page_please_note, ...newContents } });
	}
	addPermissionToPublish(newContents) {
		this.setState({ page_permission_to_publish: { ...this.state.page_permission_to_publish, ...newContents } });
	}
	addCheckbox(newContents) {
		this.setState({ page_checkbox: { ...this.state.page_checkbox, ...newContents } });
	}

	fetchAlertMessages(newContents) {
		this.setState({
		  alert_messages: { ...this.state.alert_messages, ...newContents }
		});
	}

	addError(type = '', page = '') {
		let data = {}
		if(type && page) {
			data[page] = { error: true };
			this.setState({
				[type]: {
					...this.state[type],
					...data 
				}
			})
		} else if(type) {
			this.setState({
				[type]: {					
					error: true
				}
			})
		}
	}

	componentDidMount() {
		this.props.types.forEach(type => {
			switch (type) {
				case Types.PAGE_TITLE_DESCRIPTION:
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
						if (!this.state.page_title_description[page]) {
							ContentMessagesAPIs.getPageTitleAndDescription({ name: page })
							.then(res => {
								if (res.data && res.data.length > 0) {
									let newContents = {};
									newContents[page] = res.data[0];
									this.addPageTitleAndDescriptions(newContents);
								} else {
									this.addError(Types.PAGE_TITLE_DESCRIPTION, page);
								}
							})
							.catch(e => {
								this.addError(Types.PAGE_TITLE_DESCRIPTION, page);
							});
						}
						});
					} else {						
						ContentMessagesAPIs.getPageTitleAndDescription({})
						.then(res => {
							const newContents =
							res.data &&
							res.data.reduce((acc, item) => {
								acc[item.name] = item;
								return acc;
							}, {});

							if(res.data && res.data.length > 0){
								this.addPageTitleAndDescriptions(newContents);
							} else {								
								this.addError(Types.PAGE_TITLE_DESCRIPTION);
							}
						})
						.catch(e => {
							this.addError(Types.PAGE_TITLE_DESCRIPTION);
						});
					}
				break;

				case Types.PAGE_ALERTS: 
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.alert_messages[page]) {
								ContentMessagesAPIs.getAlertMessagesFromDrupal({ name: page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data;
											this.fetchAlertMessages(newContents);
										} else {
											this.addError(Types.PAGE_ALERTS, page);
										}
									})
									.catch(e => {
										this.addError(Types.PAGE_ALERTS, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getAlertMessagesFromDrupal({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});

								if(res.data && res.data.length > 0) {
									this.fetchAlertMessages(newContents);
								} else {
									this.addError(Types.PAGE_ALERTS);
								}
							})
							.catch(e => {
								this.addError(Types.PAGE_ALERTS);
							});
					}
					break;
					case Types.PAGE_PERMISSION_TO_PUBLISH: 
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.alert_messages[page]) {
								ContentMessagesAPIs.getPTPFromDrupal({ name: page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data;
											this.addPermissionToPublish(newContents);
										} else {
											this.addError(Types.PAGE_PERMISSION_TO_PUBLISH, page);
										}
									})
									.catch(e => {
										this.addError(Types.PAGE_PERMISSION_TO_PUBLISH, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getPTPFromDrupal({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});

								if(res.data && res.data.length > 0) {
									this.addPermissionToPublish(newContents);
								} else {
									this.addError(Types.PAGE_PERMISSION_TO_PUBLISH);
								}
							})
							.catch(e => {
								this.addError(Types.PAGE_PERMISSION_TO_PUBLISH);
							});
					}
					break;

					case Types.PAGE_CHECKBOX: 
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.alert_messages[page]) {
								ContentMessagesAPIs.getCheckboxFromDrupal({ name: page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data;
											this.addCheckbox(newContents);
										} else {
											this.addError(Types.PAGE_CHECKBOX, page);
										}
									})
									.catch(e => {
										this.addError(Types.PAGE_CHECKBOX, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getCheckboxFromDrupal({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});

								if(res.data && res.data.length > 0) {
									this.addCheckbox(newContents);
								} else {
									this.addError(Types.PAGE_CHECKBOX);
								}
							})
							.catch(e => {
								this.addError(Types.PAGE_CHECKBOX);
							});
					}
					break;
				
				case Types.GET_CONFIRMATION_MESSAGE: 
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.confirmation_message[page]) {
								ContentMessagesAPIs.getConfirmationMessageFromDrupal({ name: page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data[0];
											this.getConfirmationMessage(newContents);
										} else {
											this.addError(Types.GET_CONFIRMATION_MESSAGE, page);
										}
									})
									.catch(e => {
										this.addError(Types.GET_CONFIRMATION_MESSAGE, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getConfirmationMessageFromDrupal({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});

									if(res.data && res.data.length > 0) {
										this.getConfirmationMessage(newContents);
									} else {
										this.addError(Types.GET_CONFIRMATION_MESSAGE);
									}								
							})
							.catch(e => {
								this.addError(Types.GET_CONFIRMATION_MESSAGE);
							});
					}
					break;

				case Types.SUB_HEADING_LEGACY_OPTIONS:
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.sub_headings_desc_legacy_options[page]) {
								ContentMessagesAPIs.getSubHeadingLegacyOptions({ name: page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data[0];											
											this.addSubHeadingLegacyOptions(newContents);
										} else {
											this.addError(Types.SUB_HEADING_LEGACY_OPTIONS, page);
										}
									})
									.catch(e => {
										this.addError(Types.SUB_HEADING_LEGACY_OPTIONS, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getSubHeadingLegacyOptions({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});
								
								if(res.data && res.data.length > 0) {
									this.addSubHeadingLegacyOptions(newContents);
								} else {
									this.addError(Types.SUB_HEADING_LEGACY_OPTIONS);
								}
							})
							.catch(e => {
								this.addError(Types.SUB_HEADING_LEGACY_OPTIONS);
							});
					}
					break;
				case Types.PAGE_NOTICES:
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.page_notices[page]) {
								ContentMessagesAPIs.getNotices({ page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data[0];
											this.addNotices(newContents);
										} else {
											this.addError(Types.PAGE_NOTICES, page);
										}
									})
									.catch(e => {
										this.addError(Types.PAGE_NOTICES, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getNotices({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});
								
								if(res.data && res.data.length > 0) {
									this.addNotices(newContents);
								} else {
									this.addError(Types.PAGE_NOTICES);
								}
							})
							.catch(e => {
								this.addError(Types.PAGE_NOTICES);
							});
					}
					break;
					case Types.PAGE_PLEASE_NOTE:
						if (this.props.pages && this.props.pages.length > 0) {
							this.props.pages.forEach(page => {
								if (!this.state.page_please_note[page]) {
									ContentMessagesAPIs.getPleaseNoteFromDrupal({ page })
										.then(res => {
											if (res.data && res.data.length > 0) {
												let newContents = {};
												newContents[page] = res.data;
												this.addPleaseNote(newContents);
											} else {
												this.addError(Types.PAGE_PLEASE_NOTE, page);
											}
										})
										.catch(e => {
											this.addError(Types.PAGE_PLEASE_NOTE, page);
										});
								}
							});
						} else {
							ContentMessagesAPIs.getPleaseNoteFromDrupal({})
								.then(res => {
									const newContents =
										res.data &&
										res.data.reduce((acc, item) => {
											acc[item.name] = item;
											return acc;
										}, {});
									
									if(res.data && res.data.length > 0) {
										this.addPleaseNote(newContents);
									} else {
										this.addError(Types.PAGE_PLEASE_NOTE);
									}
								})
								.catch(e => {
									this.addError(Types.PAGE_PLEASE_NOTE);
								});
						}
						break;
				case Types.PAGE_DISCLAIMERS:
					if (this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach(page => {
							if (!this.state.page_disclaimers[page]) {
								ContentMessagesAPIs.getDisclaimers({ page })
									.then(res => {
										if (res.data && res.data.length > 0) {
											let newContents = {};
											newContents[page] = res.data[0];
											this.addDisclaimers(newContents);
										} else {
											this.addError(Types.PAGE_DISCLAIMERS, page);
										}
									})
									.catch(e => {
										this.addError(Types.PAGE_DISCLAIMERS, page);
									});
							}
						});
					} else {
						ContentMessagesAPIs.getDisclaimers({})
							.then(res => {
								const newContents =
									res.data &&
									res.data.reduce((acc, item) => {
										acc[item.name] = item;
										return acc;
									}, {});
								
								if(res.data && res.data.length > 0) {
									this.addDisclaimers(newContents);
								} else {
									this.addError(Types.PAGE_DISCLAIMERS);
								}
							})
							.catch(e => {
								this.addError(Types.PAGE_DISCLAIMERS);
							});
					}
					break;
				case Types.PAGE_PDF_LINKS:
					let pdfs = ['getPDFLinks','getEndowedGrantPlanPDFLinks'];
					pdfs.forEach(pdf => {
						ContentMessagesAPIs[pdf]()
						.then(res => {
							const newContents =
								res.data &&
								res.data.reduce((acc, item) => {
									acc[item.name] = item;
									return acc;
								}, {});							
							
							if(res.data && res.data.length > 0) {
								this.addPdf(newContents);
							} else {
								this.addError(Types.PAGE_PDF_LINKS);
							}
						})
						.catch(e => {
							this.addError(Types.PAGE_PDF_LINKS);
						});
					})
					
					break;
				case Types.GET_MODAL_CONTENT:
					if(this.props.pages && this.props.pages.length > 0) {
						this.props.pages.forEach((page) => {
							ContentMessagesAPIs.getModalContent({ page })
							.then((res) => {
								if(res.data && res.data.length > 0) {
									let newContent = {};
									newContent[page] = res.data[0];
									this.addModalContent(newContent);
								} else {
									this.addError(Types.GET_MODAL_CONTENT, page);
								}
							})
							.catch(e => {
								this.addError(Types.GET_MODAL_CONTENT, page);
							})
						})		
					}
					break;
				default:
					break;
			}
		});
	}

	render() {
		return (
		<Contents.Provider value={this.state}>
			{this.props.children}
		</Contents.Provider>
		);
	}
}

ContentProvider.propTypes = {
	types: PropTypes.arrayOf(PropTypes.string),
	pages: PropTypes.arrayOf(PropTypes.string)
}

export const ContentMessage = props => {
  const { page, type, property, defaultMessage, html=false, inline=false, messageId='' } = props;
  return (
    <Contents.Consumer>
      {contents => {		  		  
        const message =
          (contents &&
            contents[type] &&
            contents[type][page] &&
            contents[type][page][property]) ||
		  defaultMessage;
		  
        if (props.setTitle) {
          props.setTitle(message);
		}

		if(!contents || (contents && contents[type] && !contents[type].error && !contents[type][page])){
			return <Preloader styling="text-loader" />
		}
        else if (html) {
          return inline ? <span dangerouslySetInnerHTML={{ __html: message }} id={`${messageId}contentSpan`}></span>: <ContentDiv id={`${messageId}contentDiv`} dangerouslySetInnerHTML={{ __html: message }} />;
        } else {
          return <>{message}</>;
        }
      }}
    </Contents.Consumer>
  );
}

ContentMessage.propTypes = {
	type: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
	page: PropTypes.string,
	property: PropTypes.string,
	defaultMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	html: PropTypes.bool,
	inline: PropTypes.bool
}

export const AlertContent = props => {
  const { page, type, keyProperty, property, defaultMessage, html=false, isButton=false, alertId='' } = props;
  return (
    <Contents.Consumer>
      {contents => {
        const contentArr =
          contents &&
          contents[type] &&
		  contents[type][page] &&
		  !contents[type][page].error &&
          contents[type][page].filter(
            item =>
              item.name.trim().toLowerCase() ===
              keyProperty.trim().toLowerCase()
      );
        const message =
          (contentArr && contentArr.length && contentArr[0][property]) || defaultMessage;
        if (props.setTitle) {
          const contentObj = contentArr.length ? contentArr[0] : {};
          props.setTitle(contentObj);
		}

        if (html) {
          return <ContentDiv dangerouslySetInnerHTML={{ __html: message }} id={`${alertId}alertContentDiv`}/>;
        } else {
			if(isButton) {
				return <span id={`${alertId}alertContentSpan`}>{message}</span>;
			} else {
				return <p id={`${alertId}alertContentParagraph`}>{message}</p>;
			}
        }
      }}
    </Contents.Consumer>
  );
};

AlertContent.propTypes = {
	page: PropTypes.string,
	type: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
	keyProperty: PropTypes.string,
	property: PropTypes.string,
	defaultMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	html: PropTypes.bool,
	isButton: PropTypes.bool,
	setTitle: PropTypes.func
}

/**
 * Use this as an HOC to pass contents to your component.
 * You will need to pass page and content type from above map
 * to filter out the content as per your page and api.
 *
 */
export const withContents = Component => props => {
  const { page, contentType } = props;
  return (
    <Contents.Consumer>
      {contents => {
        const pageContent =
          contents && contents[contentType] && contents[contentType][page];
        return <Component {...props} contents={pageContent} />;
      }}
    </Contents.Consumer>
  );
};
